<template>
  <div @click.stop.prevent="onPlayerClick">
    <div id="videoPlayer"></div>
  </div>
</template>

<script>
import {mapState} from 'vuex';
import {PLAYER_ACTIONS, API, USER_CAPABILITY, PLAYER_EVENTS} from '@/const';
/* eslint-disable */
const JwRewind60 = `<svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24">
  <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
    <path d="M19.007 16.466A6 6 0 0 0 15 6H4"/>
    <path d="M7 9L4 6l3-3m5 12.5v3a1.5 1.5 0 0 0 3 0v-3a1.5 1.5 0 0 0-3 0M9 14H7a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1H6"/>
  </g>
</svg>`;
const SlowSpeed = `<svg xmlns="http://www.w3.org/2000/svg" width="28px" height="28px" viewBox="0 0 56 56" stroke="currentColor" stroke-width="1.5px">
<path fill="currentColor" d="M4.894 42.085c3.246 0 6.592-1.415 9.24-4.145c1.847.999 3.645 1.914 6.325 1.914c2.93 0 4.761-.765 6.409-1.681c2.564 2.547 5.876 3.945 9.056 3.945c2.647 0 4.661-1.098 4.661-3.13c0-1.93-1.432-2.73-3.38-3.262c-.499-.133-.998-.25-1.497-.383c7.39-.15 7.474-3.895 12.435-3.895c4.511 0 7.857-1.565 7.857-4.661c0-6.626-3.795-10.155-8.207-10.155c-4.528 0-6.942 2.863-7.907 6.625c-.55 2.048-1.515 3.33-2.98 4.062l-1.049-1.93c-4.361-8.141-8.49-11.404-15.165-11.42c-7.225.016-10.92 3.162-16.297 13.35C2.763 30.432 0 31.115 0 33.062c0 1.366 1.049 2.281 3.163 2.281h1.715c-.716.2-1.432.383-2.081.616c-1.565.55-2.564 1.382-2.564 2.98c0 2.03 2.014 3.146 4.661 3.146m15.798-25.47c4.495 0 7.358 2.015 9.689 4.994c-2.747 2.314-6.077 3.613-9.889 3.613c-3.762 0-7.041-1.232-9.738-3.496c2.847-3.779 5.643-5.11 9.938-5.11m19.81 15.316c-.766-.583-1.648-1.682-2.18-2.614c1.814-.683 3.029-1.898 3.745-4.744c.799-3.43 2.63-5.427 5.726-5.427c3.18 0 5.827 2.93 5.827 7.241c0 1.598-2.447 2.63-4.978 2.63c-3.879 0-6.01 1.548-8.14 2.913m7.774-6.81a1.32 1.32 0 0 0 1.315-1.33c0-.733-.583-1.316-1.315-1.316c-.733 0-1.315.583-1.315 1.315a1.32 1.32 0 0 0 1.315 1.332M33.71 26.82c1.148 2.047 2.613 4.378 4.095 5.843c-.682.017-1.465 0-2.264 0c-2.48 0-4.328.45-5.876 1.065c-1.615-2.147-2.78-5.193-3.047-7.458a17.707 17.707 0 0 0 5.011-2.913c.716 1.082 1.398 2.248 2.08 3.463M5.826 32.663c-.849 0-1.714.017-2.48.067l-.133-.234c1.132-.948 2.547-2.147 3.546-4.145c.982-1.88 1.88-3.479 2.763-4.86a16.915 16.915 0 0 0 5.16 2.913c-.332 2.18-1.531 5.244-3.062 7.324c-1.515-.616-3.346-1.065-5.794-1.065m14.633 4.545c-2.913 0-4.694-1.365-6.992-2.597c1.548-2.198 2.697-5.227 3.03-7.691a17.79 17.79 0 0 0 3.995.45c1.532 0 2.947-.2 4.262-.517c.25 2.564 1.431 5.593 3.046 7.774c-2.314 1.232-4.178 2.58-7.341 2.58M2.713 38.589c0-.6.433-.999 1.715-1.315c.782-.2 2.863-.849 4.378-1.565c1.132.25 2.114.616 2.997 1.032c-2.547 2.148-4.828 3.113-6.892 3.113c-1.465 0-2.198-.466-2.198-1.265m33.677-1.265c1.282.316 1.715.716 1.715 1.315c0 .782-.733 1.249-2.198 1.249c-2.03 0-4.278-.933-6.775-2.997a12.252 12.252 0 0 1 2.847-1.148c1.498.715 3.629 1.365 4.411 1.581" />
</svg>`;
const NormalSpeed = `<svg xmlns="http://www.w3.org/2000/svg" width="28px" height="28px" viewBox="0 0 32 32" stroke="currentColor" stroke-width="0.5px">
<path fill="currentColor" d="M11 12h.844l.156-.002V12h5.6c.135-.265.291-.518.466-.756l-1.904-2.35a3.002 3.002 0 0 1 4.497-3.97l7.173 7.46A6 6 0 0 1 24.105 23a4 4 0 0 1-4 4H11a5 5 0 0 1-5-5v-2.1A5.002 5.002 0 0 1 7 10a4.99 4.99 0 0 1 4 2m8.218-5.69a1.002 1.002 0 0 0-1.502 1.325l3.008 3.713l-.658.636a3.503 3.503 0 0 0-.867 1.35l-.236.666h-7.09A4 4 0 0 0 8 17.998V22a3 3 0 0 0 3 3h5v-.5a2.5 2.5 0 0 0-2.5-2.5H12a1 1 0 1 1 0-2h1.5a4.5 4.5 0 0 1 4.5 4.5v.5h2.105a2 2 0 0 0 2-2v-2.277l1.178.213a4 4 0 0 0 3.238-7.042l-.047-.038zM6.002 17.83a5.998 5.998 0 0 1 3.023-5.043a3 3 0 1 0-3.023 5.044" />
</svg>`;
/* eslint-enable */

const videoOptions = {
  file: '',
  logo: {},
  width: '100%',
  aspectratio: '16:9',
  hlshtml: true,
  primary: 'html5',
  autostart: false,
  repeat: false,
  abouttext: 'Rudy',
  aboutlink: '/',
  cast: {},
};
export default {
  name: 'VideoPlayer',
  props: {
    options: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      player: null,
    };
  },
  watch: {
    options() {
      window.jwplayer && this.initPlayer();
    },
  },
  mounted() {
    this.loadPlayerLib();
  },
  methods: {
    loadPlayerLib() {
      if (!window.jwplayer) {
        const script = document.createElement('script');
        script.onload = () => {
          this.initPlayer();
        };

        script.src = 'https://cdn.jwplayer.com/libraries/CjZtBP3i.js';
        document.head.appendChild(script);

        this.$on('hook:beforeDestroy', () => {
          document.head.removeChild(script);
          this.player?.remove?.();
        });
      } else {
        this.initPlayer();
      }
    },
    initPlayer() {
      let options = Object.assign({}, videoOptions, this.options);

      if (this.hasAds) {
        const preroll = {
          advertising: {
            client: 'vast',
            schedule: [
              {
                offset: 'pre',
                vastxml: this.prerollXml,
              },
            ],
          },
        };
        options = Object.assign({}, options, preroll);
      }

      this.player = window.jwplayer('videoPlayer');
      this.player.setup(options);
      this.stopListeners();
      this.player.once('ready', this.emitInterface);
      this.initListeners();
      this.addRewindButton();
      this.addNormalSpeedButton();
    },
    emitInterface() {
      this.$emit(PLAYER_ACTIONS.interface, {
        [PLAYER_ACTIONS.rewind]: this.rewind,
        [PLAYER_ACTIONS.play]: this.playToggle,
        [PLAYER_ACTIONS.getTime]: this.getCurrentTime,
        [PLAYER_ACTIONS.totalTime]: this.getTotalTime,
        [PLAYER_ACTIONS.playPart]: this.playPart,
        [PLAYER_EVENTS.loadData]: this.metadataLoadListener,
        [PLAYER_ACTIONS.seek]: this.seekTo,
        [PLAYER_EVENTS.seeked]: this.onSeeked,
        [PLAYER_EVENTS.seek]: this.onSeekListener,
        [PLAYER_EVENTS.time]: this.onTimeListener,
        player: this.player,
      });
    },
    initListeners() {
      this.player?.on?.('play', () => this.$emit(PLAYER_ACTIONS.play, true));
      this.player?.on?.('pause', () => this.$emit(PLAYER_ACTIONS.play, false));
      this.player?.on?.('seek', this.onSeek);
      this.player?.on?.('error', this.onError);
      this.player?.on?.('warning', this.onError);
      this.player?.on?.('setupError', this.onError);
      this.player?.on?.('firstFrame', () => this.$emit(PLAYER_ACTIONS.firstFrame, true));
      this.player?.on?.('ready', () => this.$emit(PLAYER_ACTIONS.ready, true));
      this.player?.on?.('complete', () => this.$emit(PLAYER_ACTIONS.complete, true));
      this.player?.on?.('seeked', () => this.$emit(PLAYER_EVENTS.seek, false));
    },
    onError(err) {
      if (err?.type === 'setupError' || err?.type === 'error' || err?.sourceError?.fatal) {
        this.$emit(PLAYER_ACTIONS.play, false);
        this.$emit(PLAYER_ACTIONS.error, err);
        this.$emit(PLAYER_ACTIONS.interface, null);
      }
    },
    onSeeked(cb) {
      this.player?.on?.('seeked', cb);
      return () => this.player?.off?.('seeked', cb);
    },
    onSeekListener(cb) {
      this.player?.on?.('seek', cb);
      return () => this.player?.off?.('seek', cb);
    },
    onSeek() {
      this.$emit(PLAYER_EVENTS.seek, true);
    },
    onTimeListener(cb) {
      this.player?.on?.('time', cb);
      return () => this.player?.off?.('time', cb);
    },
    stopListeners() {
      this.player?.off?.('play');
      this.player?.off?.('pause');
      this.player?.off?.('seek');
      this.player?.off?.('error');
      this.player?.off?.('warning');
      this.player?.off?.('setupError');
      this.player?.off?.('firstFrame');
      this.player?.off?.('ready');
      this.player?.off?.('complete');
      this.player?.off?.('seeked');
    },
    onPlayerClick(e) {
      this.$emit('player-click', e);
    },
    rewind(value) {
      this.seekTo(this.player.getPosition() + value);
    },
    seekTo(value) {
      this.player.seek(value);
    },
    playBackRate(rate) {
      this.player.setPlaybackRate(rate);
    },
    playToggle(needPlay) {
      needPlay ? this.player.play() : this.player.pause();
    },
    getCurrentTime() {
      return this.player?.getCurrentTime();
    },
    getTotalTime() {
      window.player = this.player;
      return Math.abs(this.player?.getDuration());
    },
    waitTime(time) {
      let finished = false;
      const abort = () => {
        if (finished) return;
        finished = true;
        this.player.off('time');
        this.player.pause();
      };
      this.player.on('time', ({currentTime}) => {
        if (currentTime >= time) abort();
      });
      return abort;
    },
    playPart({
      start,
      end,
    } = {}) {
      this.player.seek(start);
      this.player.play();
      return this.waitTime(end);
    },
    addRewindButton() {
      this.player.addButton(
          JwRewind60,
          'Rewind 60 Seconds',
          (e) => this.rewind(-60, e),
          'jwRewind60',
          'jw-custom__rewind',
      );
    },
    addSlowDownButton() {
      this.player.addButton(
          SlowSpeed,
          'Play slowly',
          () => {
            this.playBackRate(1);
            this.player.removeButton('rate0.5');
            this.addNormalSpeedButton();
          },
          'rate0.5',
          'jw-custom__slow-speed',
      );
    },
    addNormalSpeedButton() {
      this.player.addButton(
          NormalSpeed,
          'Play with normal speed',
          () => {
            this.playBackRate(0.5);
            this.player.removeButton('rate1');
            this.addSlowDownButton();
          },
          'rate1',
          'jw-custom__normal-speed',
      );
    },
    metadataLoadListener(cb) {
      this.player?.on?.('ready', cb);
      return () => this.player?.off?.('ready', cb);
    },
  },
  computed: {
    ...mapState({
      channelSettings: (state) => state.channel?.settings,
      domain: (state) => state.channel?.settings?.sub_domain,
      capabilities: (state) => state.auth.capabilities,
    }),
    hasAds() {
      return !!this.channelSettings?.has_ads && !this.capabilities[USER_CAPABILITY.no_ads];
    },
    prerollUrl() {
      return API.PREROLL_MEDIA_HOST + '/' + this.domain + '.mp4';
    },
    prerollXml() {
      return `<VAST version="2.0"><Ad id="static"><InLine><Creatives>
        <Creative><Linear>
          <MediaFiles>
                <MediaFile type="video/mp4" bitrate="300" width="480" height="270">
              ${this.prerollUrl}
            </MediaFile>
        </MediaFiles></Linear></Creative></Creatives></InLine></Ad></VAST>`;
    },
  },

  beforeDestroy() {
    this.$emit(PLAYER_ACTIONS.interface, null);
    this.stopListeners();
  },
};
</script>

<style lang="scss">
.jw-breakpoint-7:not(.jw-flag-audio-player) {
  .jw-controlbar {
    .jw-button-container {
      .jw-icon-inline:not(.jw-text-live) {
        min-width: fit-content;
      }
    }
  }
}

#videoPlayer .jw-time-tip .jw-text {
  white-space: nowrap;
}

.jw-icon-playback {
  order: -2
}

.jw-custom__rewind {
  order: -2;
}

.jw-custom__slow-speed, .jw-custom__normal-speed {
  order: -1;
}

.jw-icon-rewind {
  display: none !important;
  visibility: hidden !important;
  opacity: 0 !important;
  width: 0 !important;
  height: 0 !important;
}
</style>
